module.exports = {"230606001":"庆葡街道","230606002":"高台子镇街道","230606004":"林源镇街道","230606005":"立志街道","230606006":"新华街道","230606007":"大同镇街道","230606100":"大同镇","230606101":"高台子镇","230606102":"太阳升镇","230606103":"林源镇","230606200":"祝三乡","230606203":"老山头乡","230606205":"八井子乡","230606206":"双榆树乡","230606500":"和平牧场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230606.json
// module id = 678
// module chunks = 0